import { conf } from '../../configService';
import { personType } from './personType';
import { organizationType } from './organizationType';
import { imageObjectType } from './imageObjectType';
import { dateService } from '../../dateService';
import {
  getContentModificationDate,
  getContentPublishDate
} from '../../../utils/contentUtils';
import { imageResizerService } from '../../imageResizerService';
import { removeEmptyProperties } from '../../../utils/objectUtils';
import { stripTags } from '../../../utils/stringUtils';
import imageProxyService from '../../imageProxyService';

export const getVideoSchemaDataFromVideoArticle = content => {
  const authors = content.authors
    ? content.authors.map(author => personType(author.entity.name))
    : [];
  const author = authors.length > 1 ? [authors] : authors[0];
  return {
    name: content.title,
    description:
      content.promoSummary?.value || content.subHeadline || content.title,
    author,
    image: content.image?.entity || content.promoImage?.[0]?.entity,
    uploadDate: getContentPublishDate(content),
    dateModified: getContentModificationDate(content),
    contentUrl: content.videoRef?.entity?.videoSource,
    embedUrl: `https://${conf.canonicalDomain}${content.url?.path}`,
    duration: content.videoRef?.entity?.duration,
    mainEntityOfPage: `https://${conf.canonicalDomain}${content.url?.path}`
  };
};

export const getVideoSchemaDataFromCard = card => {
  return {
    name: card.title,
    description: card.deck,
    uploadDate: card.date,
    dateModified: card.date,
    contentUrl: card.videoSource,
    embedUrl: `https://${conf.canonicalDomain}${card.url}`,
    duration: card.video_duration,
    mainEntityOfPage: `https://${conf.canonicalDomain}${card.url}`,
    image: card.imageEntity
  };
};

// @see https://schema.org/VideoObject
export const videoObjectType = content => {
  const imageEntity = content.image;
  const thumbnail =
    imageEntity && imageResizerService.isValidEntity(imageEntity)
      ? imageResizerService.getResizedImage(imageEntity.mediaImage, 200, {
          position: imageEntity.focalPoint,
          quality: imageResizerService.getImageEntityQuality(
            imageEntity.quality
          )
        })
      : { url: imageProxyService.getCanonicalUrl('/files/logo.16x9.png') };

  const isoDuration = dateService.secondsToIso8601(content.duration);
  return removeEmptyProperties({
    '@type': 'VideoObject',
    name: content.name,
    description: stripTags(content.description || 'National Geographic Video.'),
    thumbnailUrl: thumbnail?.url,
    uploadDate:
      content.uploadDate &&
      !Number.isNaN(Number.parseInt(content.uploadDate, 10))
        ? dateService.format(content.uploadDate * 1000, 'iso-no-milliseconds')
        : undefined,
    dateModified:
      content.dateModified &&
      !Number.isNaN(Number.parseInt(content.dateModified, 10))
        ? dateService.format(content.dateModified * 1000, 'iso-no-milliseconds')
        : undefined,
    contentUrl: content.contentUrl,
    embedUrl: content.embedUrl,
    duration: isoDuration !== 'PT0S' ? isoDuration : '',
    publisher: organizationType(),
    author: content.author || personType(conf.siteName),
    mainEntityOfPage: content.mainEntityOfPage,
    image: imageObjectType(content.image)
  });
};
